import React, { useEffect, useState } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { cn } from '@duck/ui'
import { User } from 'lucide-react'

interface UserAvatarProps {
    size?: 'sm' | 'md' | 'lg'
    className?: string
}

const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
}

const iconSizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
    size = 'md',
    className = '',
}) => {
    const { user, initials } = useAuth()
    const avatar = user?.avatar
    const [imageError, setImageError] = useState(false)

    useEffect(() => {
        setImageError(false)
    }, [avatar])

    if (avatar && !imageError) {
        return (
            <img
                src={avatar}
                alt={initials || ''}
                onError={() => setImageError(true)}
                className={cn(
                    sizeClasses[size],
                    'rounded-full object-cover border-[3px] border-primary',
                    className
                )}
            />
        )
    }

    // Show User icon as fallback when image fails or no avatar
    return (
        <div
            className={cn(
                sizeClasses[size],
                'rounded-full bg-accent flex items-center justify-center font-medium text-white',
                className
            )}
        >
            {initials ? (
                initials
            ) : (
                <User className={iconSizeClasses[size]} />
            )}
        </div>
    )
}

